export function overviewTabDTO(data) {
  return {
    id: data?.id || 0,
    connectivity: data?.connectivity || 0,
    dealClosing: data?.dealClosing || 0,
    decisionMaking: data?.decisionMaking || 0,
    evolvingAssets: data?.evolvingAssets || 0,
    smarterBuilds: data?.smarterBuilds || 0,
    userExperience: data?.userExperience || 0,
    trackRecord: data?.trackRecord || 0,
    proptechCompanyDetailsId: data?.proptechCompanyDetailsId || 0,
    proptechCompanyDetails: {
      technologyProductAdmin: data?.proptechCompanyDetails?.technologyProductAdmin || null,
      founderPitchVideo: data?.proptechCompanyDetails?.founderPitchVideo || null,
    },
    proptechAnalysisSector1: {
      id: data?.proptechAnalysisSector1?.id || 0,
      name: data?.proptechAnalysisSector1?.name || '',
    },
    proptechAnalysisSector2: {
      id: data?.proptechAnalysisSector2?.id || 0,
      name: data?.proptechAnalysisSector2?.name || '',
    },
    proptechAnalysisSector3: {
      id: data?.proptechAnalysisSector3?.id || 0,
      name: data?.proptechAnalysisSector3?.name || '',
    },
    proptechAnalysisTechOffering1: {
      id: data?.proptechAnalysisTechOffering1?.id || 0,
      name: data?.proptechAnalysisTechOffering1?.name || '',
    },
    proptechAnalysisTechOffering2: {
      id: data?.proptechAnalysisTechOffering2?.id || 0,
      name: data?.proptechAnalysisTechOffering2?.name || '',
    },
    proptechAnalysisTechOffering3: {
      id: data?.proptechAnalysisTechOffering3?.id || 0,
      name: data?.proptechAnalysisTechOffering3?.name || '',
    },
    proptechAnalysisUseCase1: {
      id: data?.proptechAnalysisUseCase1?.id || 0,
      name: data?.proptechAnalysisUseCase1?.name || '',
    },
    proptechAnalysisUseCase2: {
      id: data?.proptechAnalysisUseCase2?.id || 0,
      name: data?.proptechAnalysisUseCase2?.name || '',
    },
    proptechAnalysisUseCase3: {
      id: data?.proptechAnalysisUseCase3?.id || 0,
      name: data?.proptechAnalysisUseCase3?.name || '',
    },
    sector1: data?.sector1 || null,
    sector2: data?.sector2 || null,
    sector3: data?.sector3 || null,
    techOffering1: data?.techOffering1 || null,
    techOffering2: data?.techOffering2 || null,
    techOffering3: data?.techOffering3 || null,
    useCase1: data?.useCase1 || null,
    useCase2: data?.useCase2 || null,
    useCase3: data?.useCase3 || null,
  }
}